import { render, staticRenderFns } from "./Precautions.vue?vue&type=template&id=7e4c6d42&scoped=true"
import script from "./Precautions.vue?vue&type=script&lang=js"
export * from "./Precautions.vue?vue&type=script&lang=js"
import style0 from "./Precautions.vue?vue&type=style&index=0&id=7e4c6d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c6d42",
  null
  
)

export default component.exports